module.exports = __webpack_public_path__ + "static/media/bts_carassauga_180601_006_small.662b730d.jpg";